'use client';

import './globals.css';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html lang="es">
            <body className="antialiased min-h-screen bg-gray-100 flex items-center justify-center p-4">
                <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg border border-gray-200 text-center">
                    <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-6">
                        <AlertTriangle className="w-6 h-6 text-red-500" />
                    </div>

                    <h2 className="font-bold text-gray-900 mb-2">
                        Error crítico del sistema
                    </h2>

                    <p className="text-sm text-gray-500 mb-6">
                        Ocurrió un error irrecuperable en la aplicación.
                    </p>

                    <Button
                        onClick={reset}
                        variant="destructive"
                        className="w-full sm:w-auto"
                    >
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Recargar aplicación
                    </Button>
                </div>
            </body>
        </html>
    );
}
